import { render, staticRenderFns } from "./Procedure.vue?vue&type=template&id=3ab36a23&scoped=true&"
import script from "./Procedure.vue?vue&type=script&lang=js&"
export * from "./Procedure.vue?vue&type=script&lang=js&"
import style0 from "./Procedure.vue?vue&type=style&index=0&id=3ab36a23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab36a23",
  null
  
)

export default component.exports